import { createFileRoute } from '@tanstack/react-router'
import { BranchesPage } from '@/pages/branches'

export const Route = createFileRoute('/_authenticated/branches')({
  component: BranchesPage,
})